import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import useCategoryMenuLogic from './CategoryMenuLogic';
import BasicCategoryMenuSkin from './skins/BasicCategoryMenuSkin';

export const CategoryMenuSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.CATEGORY_MENU || 'CATEGORY_MENU',
  name: '카테고리 메뉴',
  category: 'navigation',
  supportsExternalSkins: true,
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicCategoryMenuSkin as any
  },
  useLogic: useCategoryMenuLogic as any,
  defaultProps: {
    categoryId: '',
    routingPath: '/products?category={id}',
    showProductCount: true,
    showIcon: false,
    showDescription: false,
    maxItems: 0,
    sortBy: 'name',
    sortOrder: 'asc',
    layout: 'list',
    columns: 3,
    showAllLink: true,
    allLinkText: '전체보기',
    emptyMessage: '카테고리가 없습니다.',
    skin: 'basic'
  }
};